import { Button, DialogContent, Typography } from "@mui/material";
import PromptDialogHeader from "@entrilia/shared/components/dialog/PromptDialogHeader.tsx";
import DialogButtons from "@entrilia/shared/components/DialogButtons.tsx";
import SmallDialog from "@entrilia/shared/components/SmallDialog.tsx";

interface Props {
  reportsCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

const LoseAccessConfirmation = ({ reportsCount, onCancel, onConfirm }: Props) => (
  <SmallDialog open={true} onClose={onCancel}>
    <PromptDialogHeader text="Access" onClose={onCancel} />
    <DialogContent>
      <Typography>
        You will lose access to the edit and sharing options of {reportsCount}{" "}
        {reportsCount === 1 ? "report" : "reports"} you do not own. Are you sure?
      </Typography>
    </DialogContent>
    <DialogButtons onCancel={onCancel}>
      <Button variant="outlined" color="error" onClick={onConfirm}>
        Reduce Access
      </Button>
    </DialogButtons>
  </SmallDialog>
);

export default LoseAccessConfirmation;
